var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
}


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.extras = $.extend(site.extras, {
	init: function() {
		const priceGroups = document.getElementById('priceGroups');
		const expand = document.getElementById('expandPrices');
		const shrink = document.getElementById('shrinkPrices');

		if (expand) {
			this.changePriceGroups(expand, shrink, priceGroups, 'add');
		}
		if (shrink) {
			this.changePriceGroups(shrink, expand, priceGroups,'remove');
		}
	},
	initCarousel: function() {
		const $carousel = $('#extrasBanner');
		if($carousel && $('.bannerImage', $carousel).length > 1) {
			site.owl.init($carousel.find('.bannerImages'), {
				loop: false,
				nav:false,
				dots: true,
				autoplay:false,
				smartSpeed:700,
				items: 1
			});
		}
	},
	changePriceGroups: function(a, b, priceGroups, type) {
		a.addEventListener('click', e => {
			e.preventDefault();
			a.classList.add('hidden');
			b.classList.remove('hidden');
			if (type === 'add') {
				priceGroups.classList.add('expanded');
			}
			else {
				priceGroups.classList.remove('expanded');
			}
		});
	},
});

site.dropdown = {
	init: function () {
		site.dropdown.setHeight();
		$(window).resize(function() {
			site.dropdown.setHeight();
		});

		$('.boxText','.main__categories').on('click', function(e) {
			e.stopPropagation();
		});

		$('.boxTitle a', '.main__categories').attr('href', '#').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			var $this = $(this),
				$body = $('body'),
				$box = $this.closest('.box');

			if (!$box.hasClass('open')) {
				$box.addClass('open');
				$body.addClass('dropdown-open');
			}
			else {
				site.dropdown.close();
			}
		});

		$('body').on('click', function () {
			if ($('body').is('.dropdown-open')) {
				site.dropdown.close();
			}
		});
	},

	setHeight:function() {
		var $dropdown = $('.boxText ul', '.main__categories');
		$($dropdown).each(function() {
			$(this).css('max-height', $(this)[0].scrollHeight);
		});
	},

	close:function() {
		$('.box','.main__categories').removeClass('open');
		setTimeout(function() {
			$('body').removeClass('dropdown-open');
		},400);
	}
};

site.navg = {
	init: function () {
		$('.children', '#mainmenu').each(function() {
			$this = $(this);
			$m2 = $this.find('.mmLevel2');
			$m2.css('marginLeft', '-' + ($m2.width()/2 - $this.width()/2) + 'px');
		});

		if (site.device.isTouch && window.innerWidth > 766) {
			$('.children', '#mainmenu').hover(function (e) {
				var $this = $(this)
				hover = false;
				if($this.hasClass('level1') && !$this.hasClass('hover')) {
					e.preventDefault();
					hover = true;
				}

				// close all
				$('.hover', '#mainmenu').removeClass('hover');

				if (hover) {
					$this.addClass('hover');
				}
			});
		}
	}
};

site.activity = {
	filter: function() {
		var $items = $('#extras .activity .items');
		if (!$items.length) {
			return;
		}
		var $grid = $items.isotope({
			itemSelector: '.item',
			layoutMode: 'fitRows'
		}),

		activeFilters = [],

		getActiveFilters = function() {
			return activeFilters.join(', ');
		},
		addActiveFilter = function(filter) {
			activeFilters.push(filter);
		},
		removeActiveFilter = function(filter) {
			activeFilters = activeFilters.filter(function(e) { return e !== filter })
		};


		$('.filterControls').on('click', 'a', function(e) {
			e.preventDefault();

			var $this = $(this);
			var filterValue = '.' + $this.attr('href').slice(1);

			if ($this.hasClass('all')) {
				if (!$this.hasClass('selected')) {
					$this.siblings().each(function() {
						var $sibling = $(this);
						$sibling.removeClass('selected');
						removeActiveFilter('.' + $sibling.attr('href').slice(1));
					});
					$this.addClass('selected');
				}
			}
			else {
				$(this).closest('div').find('.all').removeClass('selected');

				if (!$this.hasClass('selected')) {
					$this.addClass('selected');
					addActiveFilter(filterValue);

					if ($this.hasClass('single')) {
						$this.siblings().each(function() {
							var $sibling = $(this);
							$sibling.removeClass('selected');
							removeActiveFilter('.' + $sibling.attr('href').slice(1));
						});
					}
				}
				else {
					$this.removeClass('selected');
					removeActiveFilter(filterValue);
				}
			}

			if (activeFilters.length === 0) {
				$(this).closest('div').find('.all').addClass('selected');
			}

			$this.blur();
			$grid.isotope({ filter: getActiveFilters() });
		});
	}
};

site.frontpage = {
	init: function() {

	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.navg.init();
	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
		site.dropdown.init();
	}
	if ($body.is('.extras')) {
		if ($body.is('.hasImage')) {
			site.extras.initCarousel();
		}
		site.extras.init();
		site.activity.filter();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
